export const appElement = 'afJobs';
